export default {"src":"/_next/static/media/star-new.82b43f2e.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};